module.exports = __webpack_public_path__ + "static/media/android.07efd73a.png";